import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Link } from '@mui/internal-core-docs/Link';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Table": Table, "@mui/material/TableHead": TableHead, "@mui/material/TableBody": TableBody, "@mui/material/TableCell": TableCell, "@mui/material/TableRow": TableRow, "@mui/material/Paper": Paper, "@mui/material/Typography": Typography, "@mui/internal-core-docs/Link": { Link } } } });
export default ClientProvider;
